var paragraph_default = {
  "fontElementMap": "I-spl",
  "elementSpacing": "_7MeD-",
  "text": "kaGSD _7MeD-",
  "child": "E7CFE"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
